import React from 'react';
import Dropdown from 'react-dropdown';
import { PostToggleCard, UpgradePlanCard } from '../../components';
// import { SketchPicker } from 'react-color';
// const srcType = [
//   { value: '1', label: 'Icon' },
//   { value: '2', label: 'Name' }
// ];

let crdAction = [];

const PostCard = ({
  cnf,
  arrCard,
  currCardId,
  handleCnfChange,
  updateCardById,
  postCardValidator,
  currCategory,
  currLayout,
  fnCheckFieldIsDisplayOrNot,
  widgetType,
  handleUpgradePlan
}) => {
  if (widgetType == 'tool_team_showcase') {
    crdAction = [
      { value: '1', label: 'None' },
      { value: '2', label: 'Popup' },
    ];
  } else {
    crdAction = [
      { value: '1', label: 'None' },
      { value: '2', label: 'Popup' },
      { value: '3', label: 'Redirect' }
    ];
  }
  let crdAuthor = [
    { value: 'full_name', label: 'Show Full Name' },
    { value: 'short_fname', label: 'Shorten First Name' },
    { value: 'short_lname', label: 'Shorten Last Name' },
    { value: 'short_uname', label: 'Shorten Full Name' },
    { value: 'hide', label: 'Hide' }
  ];

  return (
    <div className="side-editor-panel side-editor-layout">
      <div className="card card-editor card-template">
        <div className="card-editor-block">
          <label className="card-editor-title">Templates</label>
          <div className="template-list">
            {
              arrCard && arrCard.map((val, key) => {
                return (
                  //reason: our 4th post card is working good in youtube, but not work for other(twitter, facebook...) 
                  //so, temporary, we display this new card in only youtube source
                  val && (val._id !== '62d93a69a042823d91d70d60' || widgetType == 'youtubevideogallery') &&
                  <div className={val._id == currCardId ? 'theme-layout-item theme-block active' : 'theme-layout-item theme-block'} key={key} onClick={() => updateCardById(val._id)}>
                    <span className="theme-layout-name">{val.tn}</span>
                    <img src={val.iu} alt="theme" />
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
      <div className="card card-editor card-customize mt-15">
        <div className="card-editor-block p-0">
          <div className='card-plan-div'>
            <label className="card-editor-title">Card Option</label>
            <UpgradePlanCard
              handleUpgradePlan={handleUpgradePlan}
            />
          </div>
          <div className="customize-list">
            {/*start Job board */}
            {cnf && cnf.jbcrdittl != undefined &&
              <PostToggleCard
                ttl={'Show card title'}
                fieldName={'jbcrdittl'}
                value={cnf.jbcrdittl}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbcrdilctn != undefined &&
              <PostToggleCard
                ttl={'Show location'}
                fieldName={'jbcrdilctn'}
                value={cnf.jbcrdilctn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbcrdislry != undefined &&
              <PostToggleCard
                ttl={'Show salary'}
                fieldName={'jbcrdislry'}
                value={cnf.jbcrdislry}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbcrdidsc != undefined &&
              <PostToggleCard
                ttl={'Show description'}
                fieldName={'jbcrdidsc'}
                value={cnf.jbcrdidsc}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbcrdidsgn != undefined &&
              <PostToggleCard
                ttl={'Show designation'}
                fieldName={'jbcrdidsgn'}
                value={cnf.jbcrdidsgn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbcrdiskl != undefined &&
              <PostToggleCard
                ttl={'Show skill'}
                fieldName={'jbcrdiskl'}
                value={cnf.jbcrdiskl}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbcrdityp != undefined &&
              <PostToggleCard
                ttl={'Show type'}
                fieldName={'jbcrdityp'}
                value={cnf.jbcrdityp}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.jbcrdicta != undefined &&
              <PostToggleCard
                ttl={'Show CTA'}
                fieldName={'jbcrdicta'}
                value={cnf.jbcrdicta}
                handleCnfChange={handleCnfChange} />
            }
            {/*end Job board */}

            {/* [S] Team_showcase */}
            {cnf && cnf.tmcrdiimg != undefined &&
              <PostToggleCard
                ttl={'Show image'}
                fieldName={'tmcrdiimg'}
                value={cnf.tmcrdiimg}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmcrdinm != undefined &&
              <PostToggleCard
                ttl={'Show name'}
                fieldName={'tmcrdinm'}
                value={cnf.tmcrdinm}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmcrdieml != undefined &&
              <PostToggleCard
                ttl={'Show email'}
                fieldName={'tmcrdieml'}
                value={cnf.tmcrdieml}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmcrdiphn != undefined &&
              <PostToggleCard
                ttl={'Show phone'}
                fieldName={'tmcrdiphn'}
                value={cnf.tmcrdiphn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmcrdipstn != undefined &&
              <PostToggleCard
                ttl={'Show position'}
                fieldName={'tmcrdipstn'}
                value={cnf.tmcrdipstn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmcrdiwbst != undefined &&
              <PostToggleCard
                ttl={'Show website'}
                fieldName={'tmcrdiwbst'}
                value={cnf.tmcrdiwbst}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmcrdilctn != undefined &&
              <PostToggleCard
                ttl={'Show location'}
                fieldName={'tmcrdilctn'}
                value={cnf.tmcrdilctn}
                handleCnfChange={handleCnfChange} />
            }
            {fnCheckFieldIsDisplayOrNot('cnf.tmcrdidsc', currLayout) && cnf && cnf.tmcrdidsc != undefined &&
              <PostToggleCard
                ttl={'Show description'}
                fieldName={'tmcrdidsc'}
                value={cnf.tmcrdidsc}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.tmcrdiscl != undefined &&
              <PostToggleCard
                ttl={'Show social profile'}
                fieldName={'tmcrdiscl'}
                value={cnf.tmcrdiscl}
                handleCnfChange={handleCnfChange} />
            }

            {/* [E] Team_showcase */}

            {/* [S] tool_youtube_gallery */}
            {cnf && cnf.vidcrdiplyicn != undefined &&
              <PostToggleCard
                ttl={'Show play icon'}
                fieldName={'vidcrdiplyicn'}
                value={cnf.vidcrdiplyicn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidcrdidrtn != undefined &&
              <PostToggleCard
                ttl={'Show duration'}
                fieldName={'vidcrdidrtn'}
                value={cnf.vidcrdidrtn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidcrdittl != undefined &&
              <PostToggleCard
                ttl={'Show title'}
                fieldName={'vidcrdittl'}
                value={cnf.vidcrdittl}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidcrdidt != undefined &&
              <PostToggleCard
                ttl={'Show date'}
                fieldName={'vidcrdidt'}
                value={cnf.vidcrdidt}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidcrdidesc != undefined &&
              <PostToggleCard
                ttl={'Show description'}
                fieldName={'vidcrdidesc'}
                value={cnf.vidcrdidesc}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidcrdiviw != undefined &&
              <PostToggleCard
                ttl={'Show view counter'}
                fieldName={'vidcrdiviw'}
                value={cnf.vidcrdiviw}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidcrdilk != undefined &&
              <PostToggleCard
                ttl={'Show like counter'}
                fieldName={'vidcrdilk'}
                value={cnf.vidcrdilk}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.vidcrdicmnt != undefined &&
              <PostToggleCard
                ttl={'Show commnents counter'}
                fieldName={'vidcrdicmnt'}
                value={cnf.vidcrdicmnt}
                handleCnfChange={handleCnfChange} />
            }
            {/* [E] tool_youtube_gallery */}

            {/* {cnf && cnf.crdiat != undefined &&
              <PostToggleCard
                ttl={'Show author name'}
                fieldName={'crdiat'}
                value={cnf.crdiat}
                handleCnfChange={handleCnfChange} />
            } */}
            {fnCheckFieldIsDisplayOrNot('cnf.crdiat', currLayout) && cnf && cnf.crdiat != undefined &&
              <div className="editor-field-list editor-dropdown customize-dropdown customize-onclick">
                <label>Author name</label>
                <Dropdown className="nf-select-dropdown nf-select-defaultdd nf-select-authorname " options={crdAuthor} value={cnf.crdiat ? cnf.crdiat.toString() : cnf.crdiat} onChange={(e) => handleCnfChange('crdiat', e.value)} />
              </div>
            }
            {cnf && cnf.crdiauicn != undefined && fnCheckFieldIsDisplayOrNot('cnf.crdiauicn', currLayout) &&
              <PostToggleCard
                ttl={'Show author icon'}
                fieldName={'crdiauicn'}
                value={cnf.crdiauicn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.crdidtm != undefined && currCardId !== '6319ab568b5efa1bb6e1599d' &&
              <PostToggleCard
                ttl={'Show date'}
                fieldName={'crdidtm'}
                value={cnf.crdidtm}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.crdiact != undefined &&
              <PostToggleCard
                ttl={'Show action'}
                fieldName={'crdiact'}
                value={cnf.crdiact}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.crdisrc != undefined &&
              <PostToggleCard
                ttl={'Show source'}
                fieldName={'crdisrc'}
                value={cnf.crdisrc}
                handleCnfChange={handleCnfChange} />
            }
            {fnCheckFieldIsDisplayOrNot('cnf.crdclkact', currLayout) && cnf && cnf.crdclkact != undefined &&
              <div className="editor-field-list editor-dropdown customize-dropdown customize-onclick">
                <label>On click action</label>
                <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={crdAction} value={cnf.crdclkact ? cnf.crdclkact.toString() : cnf.crdclkact} onChange={(e) => handleCnfChange('crdclkact', e.value)} />
              </div>
            }
            {cnf && cnf.crdihurl != undefined && fnCheckFieldIsDisplayOrNot('cnf.crdihurl', currCategory) &&
              <PostToggleCard
                ttl={'Hide URL from content'}
                fieldName={'crdihurl'}
                value={cnf.crdihurl}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.crditrm != undefined && fnCheckFieldIsDisplayOrNot('cnf.crditrm', currLayout) &&
              <div className="editor-field-list editor-toggle customize-dropdown customize-trimcntnt">
                <div className="editor-row-two">
                  <label className="label-title">Trim content</label>
                  <label className="switch">
                    <input type="checkbox" checked={cnf.crditrm} onChange={(e) => handleCnfChange('crditrm', e.target.checked)} />
                    <span className="slider round"></span>
                  </label>
                </div>
                {cnf && cnf.crditrm &&
                  <div className="editor-trimcntnt-text">
                    <input className="editor-input-content editor-input-fullwidth" type="text" value={cnf.crdrdmrtxt} onChange={(e) => handleCnfChange('crdrdmrtxt', e.target.value)} placeholder="Read more value"></input>
                    {postCardValidator.message('read more', cnf.crdrdmrtxt, 'required')}
                  </div>
                }
              </div>
            }
            {cnf && cnf.crdicptn != undefined &&
              <PostToggleCard
                ttl={'Show caption'}
                fieldName={'crdicptn'}
                value={cnf.crdicptn}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.crdwbstlg != undefined &&
              <PostToggleCard
                ttl={'Show website logo'}
                fieldName={'crdwbstlg'}
                value={cnf.crdwbstlg}
                handleCnfChange={handleCnfChange} />
            }

            {/* [S] tool_pricing */}
            {cnf && cnf.pricrdiimg != undefined &&
              <PostToggleCard
                ttl={'Show image'}
                fieldName={'pricrdiimg'}
                value={cnf.pricrdiimg}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.pricrdidesc != undefined &&
              <PostToggleCard
                ttl={'Show description'}
                fieldName={'pricrdidesc'}
                value={cnf.pricrdidesc}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.pricrdidsnt != undefined &&
              <PostToggleCard
                ttl={'Show discount'}
                fieldName={'pricrdidsnt'}
                value={cnf.pricrdidsnt}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.pricrdicta != undefined &&
              <PostToggleCard
                ttl={'Show CTA'}
                fieldName={'pricrdicta'}
                value={cnf.pricrdicta}
                handleCnfChange={handleCnfChange} />
            }
            {/* [E] tool_pricing */}

            {/* [S] tool_number_animation */}
            {cnf && cnf.numcrdiimg != undefined &&
              <PostToggleCard
                ttl={'Show image'}
                fieldName={'numcrdiimg'}
                value={cnf.numcrdiimg}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.numcrdittl != undefined &&
              <PostToggleCard
                ttl={'Show title'}
                fieldName={'numcrdittl'}
                value={cnf.numcrdittl}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.numcrdiprifx != undefined &&
              <PostToggleCard
                ttl={'Show prefix'}
                fieldName={'numcrdiprifx'}
                value={cnf.numcrdiprifx}
                handleCnfChange={handleCnfChange} />
            }
            {cnf && cnf.numcrdipstfx != undefined &&
              <PostToggleCard
                ttl={'Show postfix'}
                fieldName={'numcrdipstfx'}
                value={cnf.numcrdipstfx}
                handleCnfChange={handleCnfChange} />
            }
            {/* [E] tool_number_animation */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostCard;


// WEBPACK FOOTER //
// ./src/components/Widget/PostCard.js